import { FlexBox, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { ResponsiveRadar } from '@nivo/radar'
import { useGoalHabits } from '../../lib/ctx'
import { useStatsTheme } from 'app/webview/pages/stats_profile/theme/ctx'
import { getMonthYAxisIncrement } from '../../lib/utils'

export const RadarChart = () => {
  const { colors } = useTheme()
  const theme = useStatsTheme((s) => s.theme)
  const [data, maxValue] = useGoalHabits((s) => [s.monthData, s.monthMaxValue])

  const increment = getMonthYAxisIncrement(maxValue)
  const yAxisLength = Math.ceil(maxValue / increment)

  return (
    <ResponsiveRadar
      data={data as unknown as Record<string, unknown>[]}
      keys={['number_achieved', 'number_goals']}
      colors={[theme.colors.primary, colors.uiPearl]}
      indexBy="month"
      margin={{ top: 20, right: 30, bottom: 20, left: 30 }}
      borderWidth={3}
      borderColor={{ from: 'color' }}
      gridLabel={({ id, x, y }) => (
        <g transform={`translate(${x},${y})`}>
          <foreignObject width={40} height={40} x={-20} y={-5}>
            <Text
              type="body"
              className={css`
                font-size: 8px;
                line-height: 8px;
              `}
              color={theme.colors.section.textSecondary}
              align="center"
            >
              {id}
            </Text>
          </foreignObject>
        </g>
      )}
      sliceTooltip={({ data }) => {
        return (
          <FlexBox
            className={css`
              padding: 4px;
              min-width: 75px;
              gap: 4px;
              background-color: ${colors.uiGraphite};
              border-radius: 4px;
              box-shadow: 0px 8px 12px 0px rgba(0, 0, 0, 0.12);
            `}
            alignItems="center"
            flexDirection="column"
          >
            {data.map(({ id, value }) => {
              const getText = () => {
                switch (id) {
                  case 'number_achieved':
                    return 'Your reading'
                  case 'number_goals':
                    return 'Your goals'
                }
              }

              return (
                <Text
                  key={id}
                  type="body"
                  className={css`
                    font-size: 8px;
                    line-height: 9px;
                  `}
                  weight="500"
                  color={theme.colors.section.text}
                  align="center"
                >
                  {getText()}: <b>{value}</b>
                </Text>
              )
            })}
          </FlexBox>
        )
      }}
      gridLevels={yAxisLength}
      gridShape="linear"
      gridLabelOffset={12}
      dotSize={7}
      dotBorderWidth={3}
      dotColor={(d) =>
        !d.value || d.value === 0 ? 'transparent' : colors.uiPearlExtraLight
      }
      dotBorderColor={(d) => {
        if (d.key === 'number_achieved') {
          return !d.value || d.value === 0
            ? 'transparent'
            : theme.colors.primary
        }
        return !d.value || d.value === 0 ? 'transparent' : colors.uiPearl
      }}
      fillOpacity={0}
      theme={{
        grid: {
          line: {
            stroke: theme.colors.section.chart.lines,
            strokeDasharray: '2 4',
          },
        },
      }}
    />
  )
}
